let mockTemporarySchedule = [
  {
    id: 1,
    employeeID: '12457890004',
    code: 'A01',
    nameEnglish: 'Sudheesh Kumar',
    nameArabic: 'سودييش كومار',
    position: 'Product Manager',
    department: 'Product Revamp',
    date: '03-09-2025',
    timeTable: 'Timetable 20250831-2',
    checkIn: '8:00 AM',
    checkOut: '5:00 PM',
  },
  {
    id: 2,
    employeeID: '12457890008',
    code: 'A02',
    nameEnglish: 'Hazem Naim',
    nameArabic: 'حازم نعيم',
    position: 'Sr Software Developer',
    department: 'Product Revamp',
    date: '03-09-2025',
    timeTable: 'Timetable 20250831-2',
    checkIn: '9:00 AM',
    checkOut: '6:00 PM',
  },
  {
    id: 3,
    employeeID: '12457890001',
    code: 'A03',
    nameEnglish: 'Venkatesh Deva',
    nameArabic: 'فينكاتيش ديفا',
    position: 'Sr UI UX Designer',
    department: 'Product Revamp',
    date: '03-09-2025',
    timeTable: 'Timetable 20250831-2',
    checkIn: '2:00 PM',
    checkOut: '11:00 PM',
  },
  {
    id: 4,
    employeeID: '12457890009',
    code: 'A04',
    nameEnglish: 'Chirag Korat',
    nameArabic: 'تشيراغ كورات',
    position: 'Front End Developer',
    department: 'Product Revamp',
    date: '03-09-2025',
    timeTable: 'Timetable 20250831-2',
    checkIn: '8:00 AM',
    checkOut: '5:00 PM',
  },
   {
    id: 5,
    employeeID: '12457890010',
    code: 'A05',
    nameEnglish: 'Ahmed Hassan',
    nameArabic: 'أحمد حسن',
    position: 'Backend Developer',
    department: 'Product Revamp',
    date: '03-09-2025',
    timeTable: 'Timetable 20250831-2',
    checkIn: '8:30 AM',
    checkOut: '5:30 PM',
  },
  {
    id: 6,
    employeeID: '12457890011',
    code: 'A06',
    nameEnglish: 'Mohammed Ali',
    nameArabic: 'محمد علي',
    position: 'QA Engineer',
    department: 'Product Revamp',
    date: '03-09-2025',
    timeTable: 'Timetable 20250831-2',
    checkIn: '9:00 AM',
    checkOut: '6:00 PM',
  },
  {
    id: 7,
    employeeID: '12457890012',
    code: 'A07',
    nameEnglish: 'Sarah Johnson',
    nameArabic: 'سارة جونسون',
    position: 'Project Manager',
    department: 'Product Revamp',
    date: '03-09-2025',
    timeTable: 'Timetable 20250831-2',
    checkIn: '8:00 AM',
    checkOut: '5:00 PM',
  },
  {
    id: 8,
    employeeID: '12457890013',
    code: 'A08',
    nameEnglish: 'Fatima Ahmed',
    nameArabic: 'فاطمة أحمد',
    position: 'DevOps Engineer',
    department: 'Product Revamp',
    date: '03-09-2025',
    timeTable: 'Timetable 20250831-2',
    checkIn: '10:00 AM',
    checkOut: '7:00 PM',
  },
  {
    id: 9,
    employeeID: '12457890014',
    code: 'A09',
    nameEnglish: 'James Wilson',
    nameArabic: 'جيمس ويلسون',
    position: 'Mobile Developer',
    department: 'Product Revamp',
    date: '03-09-2025',
    timeTable: 'Timetable 20250831-2',
    checkIn: '8:00 AM',
    checkOut: '5:00 PM',
  },
  {
    id: 10,
    employeeID: '12457890015',
    code: 'A10',
    nameEnglish: 'Lina Mohammed',
    nameArabic: 'لينا محمد',
    position: 'Data Analyst',
    department: 'Product Revamp',
    date: '03-09-2025',
    timeTable: 'Timetable 20250831-2',
    checkIn: '9:30 AM',
    checkOut: '6:30 PM',
  },
  {
    id: 11,
    employeeID: '12457890016',
    code: 'A11',
    nameEnglish: 'Omar Khalid',
    nameArabic: 'عمر خالد',
    position: 'System Architect',
    department: 'Product Revamp',
    date: '03-09-2025',
    timeTable: 'Timetable 20250831-2',
    checkIn: '8:00 AM',
    checkOut: '5:00 PM',
  },
  {
    id: 12,
    employeeID: '12457890017',
    code: 'A12',
    nameEnglish: 'Noura Salem',
    nameArabic: 'نورة سالم',
    position: 'Business Analyst',
    department: 'Product Revamp',
    date: '03-09-2025',
    timeTable: 'Timetable 20250831-2',
    checkIn: '1:00 PM',
    checkOut: '10:00 PM',
  }
];

let idCounter = mockTemporarySchedule.length + 1;

const TemporaryScheduleAPI = {
  getAll: async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ data: { data: [...mockTemporarySchedule] } });
      }, 300);
    });
  },

  add: async (newData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newItem = { ...newData, id: idCounter++ };
        mockTemporarySchedule = [...mockTemporarySchedule, newItem];

        resolve({ data: { data: newItem } });
      }, 300);
    });
  },

  update: async (id, updatedData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const index = mockTemporarySchedule.findIndex((item) => item.id === id);
        if (index !== -1) {
          mockTemporarySchedule[index] = {
            ...mockTemporarySchedule[index],
            ...updatedData,
          };

          resolve({ data: { data: mockTemporarySchedule[index] } });
        }
      }, 300);
    });
  },

  delete: async (ids) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const idsToDelete = Array.isArray(ids) ? ids : [ids];

        // Filter out the items to be deleted
        mockTemporarySchedule = mockTemporarySchedule.filter(
          (item) => !idsToDelete.includes(item.id)
        );

        resolve({
          status: 200,
          data: {
            deletedCount: idsToDelete.length,
            deletedIds: idsToDelete,
          },
        });
      }, 300);
    });
  },
};

export default TemporaryScheduleAPI;
